import React from "react";

const TrashIcon = ({ size = { width: 18, height: 20 }, className }) => {
  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className} // Tailwind color control
    >
      <path
        d="M20.7705 8.01343L20.0283 21.9939C19.9436 23.5866 18.6271 24.8346 17.0322 24.8347H7.10352C5.50862 24.8346 4.1921 23.5866 4.10742 21.9939L3.36523 8.01343H20.7705Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M1 4.79541H23.3286"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.19385 4.40735V2C8.19385 1.44772 8.64156 1 9.19385 1H14.752C15.3043 1 15.752 1.44772 15.752 2V4.40735"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default TrashIcon;
